import React from "react";

// styles
import styles from "./styles.module.scss";

interface Props {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  multiple?: boolean;
  withPDF?: boolean;
  disabled?: boolean;
}

const ImageUpload = ({ handleChange, multiple, withPDF, disabled }: Props) => {
  return (
    <input
      className={styles["image_upload"]}
      type="file"
      name="picture"
      id="picture"
      multiple={multiple}
      accept={`image/x-png,image/jpeg,image/jpg,image/webp,image/png${
        withPDF ? ",application/pdf" : ""
      }`}
      style={{
        background: `url('/assets/images/svg/uploadImage.svg')`,
      }}
      disabled={disabled}
      onChange={handleChange}
      // To allow the same file to be selected simultaneously
      onClick={(event) => {
        (event.target as HTMLInputElement).value = "";
      }}
    />
  );
};

export default ImageUpload;
